import React from 'react';

import { isGreaterThanBreakpoint } from 'dpl/util/grid';
import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';

const IS_GT_MD = isGreaterThanBreakpoint('md');
const IMAGE_SIZE = IS_GT_MD ? '56px' : '48px';
const GALLERY_IMG_SIZE = IS_GT_MD ? '190px' : '268px';

export default function OwnerStorySkeleton() {
  return (
    <div className="OwnerStorySkeleton">
      <div className="flex items-center gap-12 md:gap-16 mb6">
        <SkeletonBlock
          className="br-100"
          height={IMAGE_SIZE}
          width={IMAGE_SIZE}
        />
        <div>
          <SkeletonBlock className="font-16" height="1em" width="6em" />
          <SkeletonBlock className="font-14 mt1" height="1em" width="10em" />
        </div>
      </div>
      <div className="mb4 mb6-md">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <SkeletonBlock
            className="br3"
            height={GALLERY_IMG_SIZE}
            width={IS_GT_MD ? '100%' : GALLERY_IMG_SIZE}
          />
          <SkeletonBlock
            className="br3 dn db-ns"
            height={GALLERY_IMG_SIZE}
            width={IS_GT_MD ? '100%' : GALLERY_IMG_SIZE}
          />
        </div>
      </div>
      <div className="flex flex-column gap-4">
        <SkeletonBlock className="font-16" height="1em" width="100%" />
        {IS_GT_MD && (
          <SkeletonBlock className="font-16" height="1em" width="100%" />
        )}
        <SkeletonBlock className="font-16" height="1em" width="50%" />
      </div>
    </div>
  );
}
